import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import AutoComplete from "../components/AutoComplete";
import { AllCountriesList } from "../custom-hook/AllCountriesList";
import {
  RtkEditContactModalReducer,
} from "../redux/adityaReducer";
import { useEffect } from "react";
import { portalUser } from "../redux/AxiosInstance";
import { toast } from "react-toastify";
import { ad_GetAllContactsByCCode_Json } from "../redux/dev_aditya_action";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from '@mui/icons-material/Close';
import UpdateIcon from '@mui/icons-material/Update';

const RtkUpdateContactModal = ({ open }) => {
  const { selectedContactRtk } = useSelector((state) => state.aditya);
  const Email = localStorage.getItem("EmailClient") || "";
  const password = localStorage.getItem("passwordClient") || "";
  const accId = localStorage.getItem("accIdClient") || "";
  const dispatch = useDispatch();
  const [isUpdating, setIsUpdating] = useState(false);
  const [client, setClient] = useState(
    selectedContactRtk || {
      accId: localStorage.getItem("accIdClient") || "",
      username: localStorage.getItem("EmailClient") || "",
      sPassword: localStorage.getItem("passwordClient") || "",
      Salutation: selectedContactRtk.Salutation || "",
      FirstName: selectedContactRtk.FirstName || "",
      LastName: selectedContactRtk.LastName || "",
      Add1: selectedContactRtk.Add1 || "",
      Add2: selectedContactRtk.Add2 || "",
      Add3: selectedContactRtk.Add3 || "",
      Town: selectedContactRtk.Town || "",
      PostCode: selectedContactRtk.PostCode || "",
      Country: selectedContactRtk.Country || "",
      ManagerName: selectedContactRtk.ManagerName || "",
      Role: selectedContactRtk.Role || "",
      Tel: selectedContactRtk.Tel || "",
      Mobile: selectedContactRtk.Mobile || "",
      CCode: selectedContactRtk["CCode"] || "",
      maincontact: "False",
      greeting: selectedContactRtk.greeting || "",
      Contactemail: selectedContactRtk.EMailId || "",
      AssignedManager: selectedContactRtk.AssignedManager || 0,
      emailupdate: selectedContactRtk.EMailId || "",
      CActive: selectedContactRtk.CActive || "",
      note: selectedContactRtk.note || "",
    }
  );

  useEffect(() => {
    if (selectedContactRtk) {
      setClient({
        accId: localStorage.getItem("accIdClient") || "",
        username: localStorage.getItem("EmailClient") || "",
        sPassword: localStorage.getItem("passwordClient") || "",
        Salutation: selectedContactRtk.Salutation || "",
        FirstName: selectedContactRtk.FirstName || "",
        LastName: selectedContactRtk.LastName || "",
        Add1: selectedContactRtk.Add1 || "",
        Add2: selectedContactRtk.Add2 || "",
        Add3: selectedContactRtk.Add3 || "",
        Town: selectedContactRtk.Town || "",
        PostCode: selectedContactRtk.PostCode || "",
        Country: selectedContactRtk.Country || "",
        ManagerName: selectedContactRtk.ManagerName || "",
        Role: selectedContactRtk.Role || "",
        Tel: selectedContactRtk.Tel || "",
        Mobile: selectedContactRtk.Mobile || "",
        CCode: selectedContactRtk["CCode"] || "",
        maincontact: "False",
        greeting: selectedContactRtk.greeting || "",
        Contactemail: selectedContactRtk.EMailId || "",
        AssignedManager: selectedContactRtk.AssignedManager || 0,
        emailupdate: selectedContactRtk.EMailId || "",
        CActive: selectedContactRtk.CActive || "",
        note: selectedContactRtk.note || "",
      });
    }
  }, [selectedContactRtk]);

  const handleChange = (e) => {
    setClient({ ...client, [e.target.name]: e.target.value });
  };
  const handleClose = () => {
    dispatch(RtkEditContactModalReducer(false));
  };

  const handleSubmit = async () => {
    setIsUpdating(true);
    try {
      const response = await portalUser.post("UpdateContact_Json", client);
      setIsUpdating(false);
      if (response?.data?.d == "Success") {
        toast.success("Contact updated successfully");
        handleClose();
        const payloadForGetContacts = {
          accId: accId,
          username: Email,
          sPassword: password,
          CCode:
            JSON.parse(localStorage.getItem("selectedoriginator"))
              ?.OriginatorNo || "",
        };
        dispatch(ad_GetAllContactsByCCode_Json(payloadForGetContacts));
      } else {
        toast.error(`Failed to update contact !! ${response?.data?.d}`);
      }
    } catch (e) {
      console.log(e, "Error in updateContact");
      toast.error("Failed to update contact");
    }
  };

  const titleData = [
    { label: "Mr", year: 1994 },
    { label: "Mrs", year: 1972 },
    { label: "Miss", year: 1974 },
    { label: "Ms", year: 2008 },
    { label: "Dr", year: 1957 },
    { label: "Hr", year: 1957 },
    { label: "N/A", year: 1957 },
  ];

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <Box className="d-flex align-items-center justify-content-between modal-head">
          <Box className="clearfix">
            <DialogTitle>Update Client</DialogTitle>
          </Box>
          <Button onClick={handleClose} autoFocus>
            <CloseIcon />
          </Button>
        </Box>

      <DialogContent className="pt-0">
        <Grid container spacing={2} className="mt-1">
          <Grid item xs={12} sm={6} md={2}>
            <Box className="custom-autocomplete" >
              <AutoComplete
                ComData={titleData}
                target="label"
                defaultValue={client.Salutation}
                comFun={(e, newValue) => {
                  newValue &&
                    setClient({ ...client, Salutation: newValue.label });
                }}
                lable="Title"
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <TextField
             size="small"
              label="First Name"
              required
              name="FirstName"
              value={client.FirstName}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6} md={5}>
            <TextField
              size="small"
              label="Last Name"
              name="LastName"
              value={client.LastName}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Company"
              size="small"
              name="CCode"
              value={client.CCode}
              onChange={handleChange}
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              required
              size="small"
              name="Contactemail"
              value={client?.Contactemail}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Mobile Number"
              required
              name="Mobile"
              size="small"
              value={client.Mobile}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Telephone"
              name="Tel"
              size="small"
              value={client.Tel}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} className='main-accordian'>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                Address
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Address Line 1"
                      name="Add1"
                      size="small"
                      value={client.Add1}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Address Line 2"
                      name="Add2"
                      size="small"
                      value={client.Add2}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Address Line 3"
                      name="Add3"
                      size="small"
                      value={client.Add3}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="City"
                      name="Town"
                      size="small"
                      value={client.Town}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box
                      display="flex custom-autocomplete"
                      alignItems="center"
                      mb={2}
                    >
                      <AutoComplete
                        ComData={AllCountriesList}
                        defaultValue={client.Country}
                        target="label"
                        comFun={(e, newValue) => {
                          newValue &&
                            setClient({
                              ...client,
                              Country: newValue.label,
                            });
                        }}
                        lable="Country"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Zip Code"
                      name="PostCode"
                      size="small"
                      value={client.PostCode}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>

         
        </Grid>
      </DialogContent>
      <DialogActions>
      <Grid item xs={12} className="d-flex justify-content-end me-2">
            <Button
              variant="contained"
              color="error"
              onClick={handleClose}
              sx={{ mr: 1 }}
              disabled={isUpdating}
              startIcon={<CloseIcon />}
              className="btn-red"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={isUpdating}
              className="btn-blue"
              startIcon={<UpdateIcon />}
            >
              {isUpdating ? (
                <>
                  <CircularProgress
                    size={20}
                    sx={{ color: "white", marginRight: 1 }}
                  />
                  Updating...
                </>
              ) : (
                "Update Contact"
              )}
            </Button>
          </Grid>          
        </DialogActions>
    </Dialog>
  );
};

export default RtkUpdateContactModal;
